import { InjectionToken } from '@angular/core';
import { ConfigService } from './config.service';

export interface RuntimeConfig {
    apiBaseUrl: string;
    compositionApiBaseUrl: string;
    weatherWidgetUrlTemplate?: string;
}

export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>('RUNTIME_CONFIG');

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
    const cfg = await ConfigService.load();
    return {
        apiBaseUrl: cfg.apiBaseUrl,
        compositionApiBaseUrl: cfg.compositionApiBaseUrl,
        weatherWidgetUrlTemplate: cfg.weatherWidgetUrlTemplate,
    };
}
